import React, { useState } from 'react'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import { QUEIRY_MODELS } from '../../models/QueiryModels'

type IQueiryProps = {
    queiryList:QUEIRY_MODELS[],
    setQueiryList:Function,
    ingestTrainingData:Function,
    queryWithAgent:Function
}

const QueiryForm = (props: IQueiryProps) => {
    const {queiryList,setQueiryList, ingestTrainingData, queryWithAgent} = props;

    const addQueiry = () =>{
        setQueiryList([...queiryList, {question: "",sql: ""}])
        queiryList.push()
    }

    const handleQuestionChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedQueries = [...queiryList];
        updatedQueries[index].question = e.target.value;
        setQueiryList(updatedQueries);
    };

    const handleSqlChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedQueries = [...queiryList];
        updatedQueries[index].sql = e.target.value;
        setQueiryList(updatedQueries);
    };

    return (
        <div>
            <Form className="queiryForm">
                <div className='title'>
                    <div className='left'>Fine Tuning Agent</div>
                    <Button type='button' className='right' onClick={()=>addQueiry()}>Add New Query</Button>
                </div>
                {queiryList?.map((ele: any,index:number) =>
                    <FormGroup className='queiryGroup'>
                        <div className='inputGroup'>{index+1}.
                            <Input
                                className='question'
                                id="question"
                                name="question"
                                placeholder="Add question"
                                type="text"
                                value={ele?.question}
                                onChange={(e) => handleQuestionChange(e, index)}
                            ></Input>
                        </div>
                        <div className='queiryPanel'>
                            <Input
                                className='queiry'
                                id="queiry"
                                name="queiry"
                                placeholder="Add queiry"
                                type="text"
                                value={ele?.sql}
                                onChange={(e) => handleSqlChange(e, index)}
                            ></Input>
                        </div>
                        <div className='submits'>
                            <Button type='button' className='run-button' onClick={()=>ingestTrainingData()}>Submit</Button>
                            <Button type='button' className='run-button' onClick={()=>queryWithAgent(ele)}>Run</Button>
                        </div>
                    </FormGroup>
                )}
            </Form>
        </div>
    )
}

export default QueiryForm